module.exports = __webpack_public_path__ + "static/media/medical-drip.f9d22ed8.svg";